export function isEmpty(obj: object) {
  for (const key in obj) {
    if (obj[key]) {
      return false;
    }
  }
  return true;
}
